import React, { useContext, useEffect, useState } from "react";
import { Container } from "components/Container";
import { useHistory } from "react-router";
import * as atoms from "./EditarSeccionStore";
import { useAtom } from "jotai";
import { useModalConfirmar } from "store/global";
import { ModalConfirmar } from "components/Modal/ModalConfirmar";
import {SeccionEditar} from "./seccion-editar";
import SeccionService from "services/SeccionService";
import { notification } from "antd";

const EditarSeccionPage = () =>{

    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [seccion]=useAtom(atoms.seccionAtom);
    const cerrarModalConfirmacion = useModalConfirmar(state => state.cerrarModal);

    const onClickRetornarListarSecciones=()=>{
        history.push("/seccion");
    }
    const onClickBtnCancelarModal=()=>{
        cerrarModalConfirmacion();
    }
    const onClickBtnConfirmarModal = async ()=>{
        try {
            setLoading(true);
            const _seccion= await SeccionService.actualizar(seccion);
            setLoading(false);
            cerrarModalConfirmacion();
            history.push("/seccion");
            
        } catch (error) {
            console.error(error);
            cerrarModalConfirmacion();
            notification.error({
                message:"Error",
                description:error.response.data.mensaje});
            
        }finally{
            setLoading(false);
        }

    }
    return(
        <Container titulo="Editar Sección" onClickRetornar={onClickRetornarListarSecciones}>
         <SeccionEditar/>
         <ModalConfirmar
                loading={loading}
                mensaje="¿Está seguro de actualizar la Sección? "
                onClickBtnCancelar={onClickBtnCancelarModal}
                onClickBtnConfirmar={onClickBtnConfirmarModal} />
        </Container>
    )

}
export default EditarSeccionPage;